import appStore from 'store';
import api from './api';
import {
    ALL_DEPOSIT_ENSURED
  } from './constants';
const store = {
    namespaced: true,
    state: {
        MerchantList: [], //获取商家申请记录列表
        MerchantListTotal: 0,
        MerchantDetail: {}, //商家详情
        OtcPayeeList: [], //收款人审核列表
        OtcPayeeListTotal: 0,
        UpgradeList: [], //商户升级列表
        OrderList: [], //订单列表
        OrderListTotal: 0,
        adList: [], //广告列表
        adListTotal: 0,
        guidancePrice: 0, //指导价,
        guidanceCoinType: '', //指导币种
        allegeList: [], //申诉列表
        frozenList: [],
        frozenListTotal: 0,
        allegeListTotal: 0,

    },
    getters: {

    },
    mutations: {
        setPagination(state, payload) {
            state.pagination = payload;
        },

        setMerchantRecordList(state, list) {
            state.MerchantList = list.list;
            state.MerchantListTotal = list.totalCount;
        },

        setOtcPayeeList(state, list) {
            state.OtcPayeeList = list.list;
            state.OtcPayeeListTotal = list.totalCount;
        },
        setUpgradeList(state, list) {
            state.UpgradeList = list;
        },

        orderList(state, list) {
            state.OrderListTotal = list.totalCount;
            state.OrderList = list.list.slice().map(item => {
                return {
                  ...item,
                  __allDepositEnsured: ALL_DEPOSIT_ENSURED[item.allDepositEnsured]
                };
            });
            // state.OrderList = list.list;
        },

        adList(state, list) {
            console.log(list)
            state.adList = list.list;
            state.adListTotal = list.totalCount;
            state.guidancePrice = list.list[0].indexPrice.toFixed(2);
            state.guidanceCoinType = list.list[0].currencyCoin;
        },

        OtcAllegeList(state, list) {
            state.allegeList = list.list;
            state.allegeListTotal = list.totalCount;
            console.log("list", list)


        },
        getotcFrozenList(state, list) {
            state.frozenList = list.list;
            state.frozenListTotal = list.totalCount;
        },
    },
    actions: {

        detail({ commit }, id) {
            api.getAuditDetail(id).then(({ data }) => {
                commit('setAuditDetail', data);
            });
        },

        clearAuditList({ commit }) {
            commit('resetAuditList');
        },




        //获取商家申请记录列表
        getMerchantRecordList({ commit }, data) {
            console.log(data)
            api.getMerchantRecordList(data).then(res => {
                if (!res.code) {
                    commit('setMerchantRecordList', res.data);
                }
            });
        },

        //商家详情
        getMerchantDetail({ commit }, data) {
            api.getMerchantDetail(data).then(res => {
                console.log("商家详情")
                if (!res.code) {
                    commit('setMerchantDetail', res.data);
                }
            });
        },

        //收款人详情
        getPayeeDetail({ commit }, data) {
            api.getPayeeDetail(data).then(res => {
                console.log("收款人详情")
                if (!res.code) {
                    commit('setPayeeDetail', res.data);
                }
            });
        },

        //获取商家申请记录列表
        getOtcPayeeList({ commit }, data) {
            api.getOtcPayeeList(data).then(res => {
                console.log(res)
                if (!res.code) {
                    commit('setOtcPayeeList', res.data);
                }
            });
        },

        //商家升级列表
        getUpgradeList({ commit }, data) {
            api.getUpgradeList(data).then(res => {
                console.log(res)
                if (!res.code) {
                    commit('setUpgradeList', res.data.list);
                }
            });
        },


        //订单列表
        getOrderList({ commit }, data) {
            api.getOrderList(data).then(res => {
                console.log("订单列表", res)
                if (!res.code) {
                    commit('orderList', res.data);
                }
            });
        },
        //广告审核
        advertising({ commit }, data) {
            console.log("广告传过来的data", data)
            api.advertising(data).then(res => {
                console.log("订单列表", res)
                if (!res.code) {
                    commit('adList', res.data);
                }
            });
        },



        //申诉列表
        getOtcAllegeList({ commit }, data) {
            api.getAllegeList(data).then(res => {
                console.log("申诉列表", res)
                if (!res.code) {
                    commit('OtcAllegeList', res.data);
                }
            });
        },



        //冻结列表
        getotcFrozenList({ commit }, data) {
            api.getotcFrozenList(data).then(res => {
                console.log("冻结列表啊", res)
                if (!res.code) {
                    commit('getotcFrozenList', res.data);
                }
            });
        },
    }
};

appStore.registerModule('otc', store);